<link rel="preload" as="image" href="assets/StVinClin/STVincentsClinic.webp" type="image/webp" />

<div class = "page-container">
  <app-banner-logo>
    <app-banner-image banner-media [imageSrc]="'./assets/StVinClin/STVincentsClinic.webp'" fitMode="natural"></app-banner-image>
  </app-banner-logo>

  <div class = "main-body">

    <div class="section-container">
      <h1 class = "mat-display-medium">Contact Us</h1>
    </div>

    <div class="section-container">
      <h2 class = "mat-display-small">St Vincent's Clinic</h2>
        <p>We are located within St Vincent’s Clinic next door to St Vincent’s Private Hospital on the corner of Oxford and
        Victoria Streets Darlinghurst.</p>
    </div>

    <div class = 'site-detail-header'>
      <div class = "address-container">
        <h3 class="mat-headline-large">Address</h3>
          <p>Sydney Advanced Endocrinology</p>
          <p>Suite 506</p>
          <p>Level 5 St Vincent's Clinic</p>
          <p>438 Victoria St</p>
          <p>Darlinghurst NSW 2010</p>
      </div>

      <div class = "contact-container">
        <h3 class="mat-headline-large">Get in Touch</h3>
        <p><mat-icon>phone</mat-icon>(02) 8382 6575</p>
        <p><mat-icon>email</mat-icon> <a href="mailto:reception506@svha.org.au">reception506&#64;svha.org.au</a></p>
        <p><mat-icon>fax</mat-icon> (02) 8382 6578</p>
        <app-button-shared buttonType="enquire" variant="flat" color="primary"></app-button-shared>
      </div>
    </div>

    <div class="section-container">
      <h2 class = "mat-display-small">Map</h2>
      <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3312.3304180729106!2d151.2195333!3d-33.8811432!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12afbdca1d7a93%3A0x80b7646b5b9c67ea!2sSydney%20Advanced%20Endocrinology!5e0!3m2!1sen!2sau!4v1763069758201!5m2!1sen!2sau" 
        width="600" height="450"
        style="border:0;"
        allowfullscreen=""
        loading= "lazy"
        referrerpolicy="no-referrer-when-downgrade">
      </iframe>
    </div>

<div class="section-container">
  <h2 class = "mat-display-small">Transport</h2>
  <p>St Vincent's Clinic is easily accessible by car, public transport or on foot.</p>
  <app-button-shared buttonText = "Find Out More" variant="flat" color="primary" buttonLink = "https://www.stvincentsclinic.com.au/getting-here/how-to-get-here"></app-button-shared>
</div >

    <div class="section-container">
      <h2 class = "mat-display-small">Parking</h2>
  <p>Detailed parking information is available on the St Vincent's Clinic website.</p>
  <app-button-shared buttonText = "Find Out More" variant="flat" color="primary" buttonLink = "https://www.stvincentsclinic.com.au/getting-here/parking"></app-button-shared>
</div>
</div>
</div>
